import intlLocale from './intlLocale';

const formatCurrency = (currency, value) => {
  return new Intl.NumberFormat(
    intlLocale(), { style: 'currency', currency: currency, currencyDisplay: 'symbol'}
  ).format(value);
};

export default formatCurrency;
